module.exports = __webpack_public_path__ + "img/galery-inge-v9-1.2d0ac002.jpg";